import { FC } from 'react'

import { FinanceInvoice } from '@/api/models/finance'
import { useOpenInvoiceFile } from '@/components/entities/finance/hooks/useOpenInvoiceFile'
import { BillsListItem } from '@/components/pages/bill/ui/BillsListItem/BillsListItem'
import InfoModal from '@/components/shared/modal/ui/InfoModal'

type Props = {
  invoices: FinanceInvoice[]
}

const BillsListItemInfoModal: FC<Props> = ({ invoices }) => {
  const { isModalOpen, setIsModalOpen, handleOpenFile } = useOpenInvoiceFile()

  return (
    <>
      <ul className="flex flex-col gap-16 md:gap-8">
        {invoices.map(invoice => (
          <BillsListItem
            key={invoice.id}
            invoice={invoice}
            unpaid
            variant="secondary"
            onFileLinkClick={handleOpenFile}
          />
        ))}
      </ul>
      <InfoModal
        headerText="Файл не найден"
        text="Обратитесь в Службу комфорта Sminex"
        visible={isModalOpen}
        setVisibility={setIsModalOpen}
      />
    </>
  )
}

export { BillsListItemInfoModal }
